import { classNames } from "@circle-react/helpers/twMergeWithCN";
import type { ReactNode } from "react";

interface PartnerBadgeAnimatedBorderProps {
  children: ReactNode;
  className?: string;
}

export const PartnerBadgeAnimatedBorder = ({
  children,
  className,
}: PartnerBadgeAnimatedBorderProps) => (
  <div className={classNames("group/badge relative rounded-xl", className)}>
    <div
      aria-hidden
      className="circle-ai-animated-ring comet-border pointer-events-none absolute inset-0 rounded-[inherit] opacity-0 transition-opacity duration-700 group-hover/badge:opacity-100 motion-reduce:transition-none"
    />
    {children}
  </div>
);
